<footer id="footer" class="bg-light-purple text-white text-center bottom-0 w-full py-10">
  <div class="content-contain flex justify-center ">
    <img src="assets/images/PRISM_LOGO_2.png" alt="cde logo" class="w-60 sm:w-45 xl:w-80">
  </div>  

  <prism-navbar *ngIf="!isSiteOffline" (openLoginModal)="toggleModal (HeaderModalType.Login)" [isFooter]="true">
  </prism-navbar>
</footer>
